"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const history_location_1 = require("./history-location");
const reduce_filters_1 = require("./reduce-filters");
class FilterStore {
    constructor(history) {
        this.history = history;
        this.listeners = new Set();
        this.filters = reduce_filters_1.reduceFilters(history_location_1.createFiltersFromLocation(history.location));
    }
    get() {
        return this.filters;
    }
    update(action) {
        const newFilters = reduce_filters_1.reduceFilters(this.filters, action);
        if (newFilters !== this.filters) {
            this.filters = newFilters;
            for (const listener of this.listeners) {
                listener(action);
            }
            this.history.replace(history_location_1.createLocationForFilters(this.filters));
        }
    }
    listen(listener) {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }
}
exports.FilterStore = FilterStore;
//# sourceMappingURL=filter-store.js.map